import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxAFSMxPsychomotorSchema(),
          apiClient.catPhysicPsychomotForwardBack(),
          apiClient.catPhysicPsychomotRightLeft(),
          apiClient.catPhysicPsychomotDisplaCondi(),
          apiClient.catPhysicPsychomotMuscleCondi(),
          apiClient.catPhysicPsychomotKinetCondi(),
        ]);
        const [
          schemaRes,
          catPhysicPsychomotForwardBack,
          catPhysicPsychomotRightLeft,
          catPhysicPsychomotDisplaCondi,
          catPhysicPsychomotMuscleCondi,
          catPhysicPsychomotKinetCondi,
        ] = responses.map((res) => res?.data ?? {});

        let id1 = 'A';
        const resCat1 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionA = resCat1.data.data;

        let id2 = 'B';
        const resCat2 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionB = resCat2.data.data;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[0].schemaForm.physic_psychomot_forward_back.items =
          catPhysicPsychomotForwardBack.data ?? [];
        schema.schemaFormItems[0].schemaForm.physic_psychomot_right_left.items =
          catPhysicPsychomotRightLeft.data ?? [];
        schema.schemaFormItems[0].schemaForm.displacement_level_description_id.items =
          catLevelDescriptionA;
        schema.schemaFormItems[0].schemaForm.physic_psychomot_displacement.items =
          catPhysicPsychomotDisplaCondi.data ?? [];
        schema.schemaFormItems[0].schemaForm.muscle_tone_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[0].schemaForm.physic_psychomot_muscle_tone.items =
          catPhysicPsychomotMuscleCondi.data ?? [];
        schema.schemaFormItems[0].schemaForm.motor_activity_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.physic_psychomot_kinet_harmos.items =
          catPhysicPsychomotKinetCondi.data ?? [];
        schema.schemaFormItems[1].schemaForm.motor_skills_gross_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.motor_skills_fine_level_description_id.items =
          catLevelDescriptionB;

        const modelFormItems = [{ modelForm: {} }, { modelForm: {} }];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAFSMxPsychomotor(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));
        modelSlides.physical_psychomotricity_id =
          dataModelFormItems[0].modelForm.physical_psychomotricity_id;

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxAFSMxPsychomotor(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.modelSlides.physical_psychomotricity_id;
        await apiClient.updateCAxAFSMxPsychomotor(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
